/**
 * Lightweight feature gate handler for the dashboard editor.
 */
export default class DashboardFeatureHandler {
    /**
     * Create a dashboard data provider instance.
     *
     * @param {*} features
     * @param {*} callbackMethod
     */
    constructor(features, callbackMethod) {
        this.features = features;
        this.callbackMethod = callbackMethod;
    }

    /**
     * Return all configured editor features.
     */
    getFeatures() {
        return this.features;
    }

    /**
     * Resolve one feature definition by id.
     */
    getFeature(id) {
        return this.features?.find((feature) => feature.id === id);
    }

    /**
     * Check whether a feature is enabled and optionally report unsupported state.
     */
    featureSupported(id, ignoreCallback = false) {
        const feature = this.getFeature(id);
        if (!feature) {
            return true;
        }

        if (!feature.supported) {
            if (!ignoreCallback && this.callbackMethod) {
                this.callbackMethod(feature?.messageUnsupported);
            }
            return false;
        }

        return true;
    }
}
